import { createBlock, openBlock, normalizeProps, guardReactiveProps } from "vue";
import QrcodeVue from "qrcode.vue";
const _sfc_main = {
  __name: "BanzaQRCode",
  props: {
    value: {
      type: String,
      required: true,
      default: ""
    },
    size: { type: Number, default: 200 },
    margin: { type: Number, default: 4 },
    level: { type: String, default: "H" },
    background: { type: String, default: "#fff" },
    foreground: { type: String, default: "#000" },
    renderAs: { type: String, default: "svg" },
    imageSettings: { type: Object, default: () => ({}) }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(QrcodeVue, normalizeProps(guardReactiveProps(props)), null, 16);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFRUkNvZGUudnVlLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9CYXNlL0JhbnphUVJDb2RlLnZ1ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8dGVtcGxhdGU+XG5cdDxxcmNvZGUtdnVlIHYtYmluZD1cInByb3BzXCIgLz5cbjwvdGVtcGxhdGU+XG5cbjxzY3JpcHQgc2V0dXA+XG5pbXBvcnQgUXJjb2RlVnVlIGZyb20gXCJxcmNvZGUudnVlXCI7XG5cbmNvbnN0IHByb3BzID0gZGVmaW5lUHJvcHMoe1xuXHR2YWx1ZToge1xuXHRcdHR5cGU6IFN0cmluZyxcblx0XHRyZXF1aXJlZDogdHJ1ZSxcblx0XHRkZWZhdWx0OiBcIlwiLFxuXHR9LFxuXHRzaXplOiB7IHR5cGU6IE51bWJlciwgZGVmYXVsdDogMjAwIH0sXG5cdG1hcmdpbjogeyB0eXBlOiBOdW1iZXIsIGRlZmF1bHQ6IDQgfSxcblx0bGV2ZWw6IHsgdHlwZTogU3RyaW5nLCBkZWZhdWx0OiBcIkhcIiB9LFxuXHRiYWNrZ3JvdW5kOiB7IHR5cGU6IFN0cmluZywgZGVmYXVsdDogXCIjZmZmXCIgfSxcblx0Zm9yZWdyb3VuZDogeyB0eXBlOiBTdHJpbmcsIGRlZmF1bHQ6IFwiIzAwMFwiIH0sXG5cdHJlbmRlckFzOiB7IHR5cGU6IFN0cmluZywgZGVmYXVsdDogXCJzdmdcIiB9LFxuXHRpbWFnZVNldHRpbmdzOiB7IHR5cGU6IE9iamVjdCwgZGVmYXVsdDogKCkgPT4gKHt9KSB9LFxufSk7XG48L3NjcmlwdD5cbiJdLCJuYW1lcyI6WyJfb3BlbkJsb2NrIiwiX2NyZWF0ZUJsb2NrIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBT0EsVUFBTSxRQUFROztBQU5iLGFBQUFBLFVBQUEsR0FBQUMsWUFBNkIsNkNBQVQsS0FBSyxDQUFBLEdBQUEsTUFBQSxFQUFBO0FBQUE7OzsifQ==
